import script from "./RegUser.vue?vue&type=script&setup=true&lang=js"
export * from "./RegUser.vue?vue&type=script&setup=true&lang=js"

import "./RegUser.vue?vue&type=style&index=0&id=11ae228e&lang=scss&scoped=true"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ae228e"]])

export default __exports__